/**
 * 使用消息提示(自带地区参数)
 * @return {object} { info: function, warning: function, success: function, error: function }
 */
export const useMessage = () => {
    const info = window.FEGOEditor.app.stage.$message;
    const { warning, success, error } = info;
    return {
        info,
        warning,
        success,
        error
    };
};
